import {
  addressSchema,
  GetOfficesAgendasListApiPayload,
  UnauthorizedError,
} from '@omecare/utils';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import http from '@/utils/http.service';

const officeAgendaItemSchema = z.object({
  // office identifier
  id: z.string().uuid(),
  name: z.string(),
  address: addressSchema,
  createdAt: z.coerce.date(),
});
export type OfficeAgendaItemResponse = z.infer<typeof officeAgendaItemSchema>;

const getOfficesAgendasListResponseSchema = z.object({
  page: z.number(),
  per_page: z.number(),
  page_count: z.number(),
  data: z.array(officeAgendaItemSchema),
});

export type GetOfficesAgendasListResponse = z.infer<
  typeof getOfficesAgendasListResponseSchema
>;

const getOfficesAgendas =
  (params: GetOfficesAgendasListApiPayload) => async () => {
    return http.offices
      .getAgendasList(params)
      .then<GetOfficesAgendasListResponse>(({ response, transform }) => {
        return transform.handle({
          response,
          attributes: {
            name: true,
            address: true,
            createdAt: true,
          },
          schema: getOfficesAgendasListResponseSchema,
        });
      });
  };

export const useGetOfficesAgendasQuery = (
  params: GetOfficesAgendasListApiPayload,
  options?: { enabled?: boolean },
): UseQueryResult<GetOfficesAgendasListResponse, UnauthorizedError> => {
  return useQuery({
    queryFn: getOfficesAgendas(params),
    queryKey: ['offices-agendas', params.doctorSubstituteId],
    retry: false,
    enabled: options?.enabled,
  });
};
